export default __webpack_public_path__ + "styles/sphinx-book-theme.css";